import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function getTelephoneDigits(value) {
  return String(value || '').replace(/\D/g, '');
}

export function isValidTelephoneNumber(value) {
  const raw = String(value || '').trim();
  if (!raw) return false;

  const normalized = raw.startsWith('+') ? raw : `+${raw}`;
  const phoneNumber = parsePhoneNumberFromString(normalized);

  return phoneNumber ? phoneNumber.isValid() : false;
}

export function formatTelephoneNumber(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';

  const normalized = raw.startsWith('+') ? raw : `+${raw}`;
  const phoneNumber = parsePhoneNumberFromString(normalized);

  return phoneNumber?.isValid() ? phoneNumber.number : raw;
}
